import customerStateMock from './customer-states.json'
import filtersMock from './filters.json'
import initialValueMock from './initial-value.json'
import members from './members.json'
import personaMock from './persona.json'
import pointHistoriesMock from './point-histories.json'
import selfCaresMock from './self-cares.json'
import questionTypesMock from './question-types.json'

export {
  customerStateMock,
  filtersMock,
  initialValueMock,
  members,
  personaMock,
  pointHistoriesMock,
  selfCaresMock,
  questionTypesMock,
}
